import { HttpContextToken, HttpErrorResponse } from '@angular/common/http';

// Expected errors are still displayed, but do not become unhandled exceptions.
export const EXPECTED_HTTP_ERROR = new HttpContextToken<
  (error: HttpErrorResponse) => boolean
>(() => () => false);

// Let the request's caller handle these errors without a global error dialog.
export const LOCALLY_HANDLED_HTTP_ERROR = new HttpContextToken<
  (error: HttpErrorResponse) => boolean
>(() => () => false);
